import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.find.js";
import BOT_USER_AGENTS from '~/const/botUserAgent';
var isSearchEngine = function isSearchEngine(agent) {
  return !!BOT_USER_AGENTS.find(function (bot) {
    return agent && agent.toLowerCase().includes(bot.toLowerCase());
  });
};
export default isSearchEngine;